// extracted by mini-css-extract-plugin
module.exports = {"image":"image-styles_image__1WFjE","close":"image-styles_close__2PT5G"};